import { createAsyncThunk } from '@reduxjs/toolkit';
import BranchesAndTeamsService from '@/services/BranchesAndTeamsService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`BranchesAndTeams/${name}`, (arg, thunkAPI) =>
    asyncFunction(arg, thunkAPI)
  );

export const fetchBranches = handler('fetchBranches', (params) =>
  BranchesAndTeamsService.listBranches(params)
);

export const fetchTeams = handler('fetchTeams', (params) =>
  BranchesAndTeamsService.listTeams(params)
);

export const createTeam = handler('createTeam', (params) =>
  BranchesAndTeamsService.createTeam(params)
);

export const createBranch = handler('createBranch', (params) =>
  BranchesAndTeamsService.createBranch(params)
);

export const updateBranch = handler('updateBranch', ({ branchId, ...params }) =>
  BranchesAndTeamsService.updateBranch(branchId, params)
);

export const fetchBranch = handler('fetchBranch', (branchId) =>
  BranchesAndTeamsService.getBranch(branchId)
);

export const deleteBranch = handler(
  'deleteBranch',
  ({ branchId, reassignTo }) =>
    BranchesAndTeamsService.deleteBranch(branchId, { reassignTo })
);

export const deleteTeam = handler('deleteTeam', (teamId) =>
  BranchesAndTeamsService.deleteTeam(teamId)
);

export const updateTeam = handler('updateTeam', ({ teamId, ...params }) =>
  BranchesAndTeamsService.updateTeam(teamId, params)
);

export const fetchTeam = handler('fetchTeam', (teamId) =>
  BranchesAndTeamsService.getTeam(teamId)
);

export const fetchPermissionGroups = handler('fetchPermissionGroups', () =>
  BranchesAndTeamsService.listPermissionGroups()
);

export const searchAgents = handler('searchAgents', ({ q }) =>
  BranchesAndTeamsService.searchAgents({ q })
);

export const fetchBranchMembers = handler('fetchBranchMembers', (branchId) =>
  BranchesAndTeamsService.listBranchMembers(branchId)
);

export const moveBranchMember = handler(
  'moveBranchMember',
  ({ branchId, ...payload }) =>
    BranchesAndTeamsService.moveBranchMember(branchId, payload)
);

export const fetchTeamMembers = handler('fetchTeamMembers', (teamId) =>
  BranchesAndTeamsService.listTeamMembers(teamId)
);

export const addTeamMember = handler('addTeamMember', ({ teamId, userId }) =>
  BranchesAndTeamsService.addTeamMember(teamId, { userId })
);

export const removeTeamMember = handler(
  'removeTeamMember',
  ({ teamId, userId }) =>
    BranchesAndTeamsService.removeTeamMember(teamId, userId)
);
